export default __webpack_public_path__ + "static/media/upmenu-light.5c24d509.svg";